import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import useUser from '@shared/utils/hooks/useUser';
import { useQuery } from '@tanstack/react-query';
import { client } from '../utils/trpc';

// The pool only funds bot cost, so the tag fee and award gives must come from
// the user's balance; the pool covers only the bot cost the balance can't.
export const useTronAffordability = t0 => {
  const $ = _c(6);
  const {
    tagEditFee,
    botCost,
    awardCost: t1
  } = t0;
  const awardCost = t1 === undefined ? 0 : t1;
  const {
    currentUser
  } = useUser();
  const total = tagEditFee + botCost + awardCost;
  const balanceFunded = tagEditFee + awardCost;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["poolStatus"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = total > 0;
  let t4;
  if ($[1] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: _temp,
      enabled: t3,
      refetchOnWindowFocus: false
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const {
    data: poolStatus
  } = useQuery(t4);
  const poolDrawable = poolStatus?.myAccess ? Math.min(poolStatus.myRemaining4h, poolStatus.poolRemaining4h, poolStatus.balance) : 0;
  const balanceForBot = Math.max(0, currentUser.tronsBalance - balanceFunded);
  const botPoolNeeded = Math.max(0, botCost - balanceForBot);
  const insufficientTrons = total > 0 && (currentUser.tronsBalance < balanceFunded || botPoolNeeded > poolDrawable);
  const poolCoversRemainder = !insufficientTrons && botPoolNeeded > 0;
  let t5;
  if ($[3] !== insufficientTrons || $[4] !== poolCoversRemainder) {
    t5 = {
      insufficientTrons,
      poolCoversRemainder
    };
    $[3] = insufficientTrons;
    $[4] = poolCoversRemainder;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
function _temp() {
  return unwrapFromResult(client.pool.status.query());
}